import { ApiRoute } from 'api-base-refrence';
import { NestjsPageFilter } from 'nestjs-model-utility';
import { InformationModel } from 'src/domains/charts/model/information/information.model';
import { InformationApiRoute } from './information.api';

export class ChartTreemapSubsegmentApiRoute extends ApiRoute {
  static apiName = 'report__customer_segmentation';
  static parent = InformationApiRoute;
  static urlPattern(
    filter?: NestjsPageFilter<keyof InformationModel.treemapSubsegment>,
  ) {
    return '/chart-treemap-subsegment';
  }
}
